import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

import { SnCallSign } from '@lib/api/entities';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'fs-call-sign-list',
  templateUrl: './call-sign-list.component.html',
  styleUrls: ['./call-sign-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-call-sign__chip-list',
  },
})
export class CallSignListComponent extends SnListBaseComponent<SnCallSign> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnCallSign): any {
    return item.id;
  }
}
